import { __rest } from "tslib";
export default function cleanProps(props) {
    var createAnalyticsEvent = props.createAnalyticsEvent, cleanedProps = __rest(props, ["createAnalyticsEvent"]);
    return cleanedProps;
}
//# sourceMappingURL=cleanProps.js.map